<template>
  <div>
    <div class="height-100">
      <loading v-show="load"/>
      <div v-show="!load" class="container-fluid py-3">
        <div class="row align-items-center">
          <div class="col-6">
            <h6 class="mb-0 font-weight-bold">Impressora</h6>
          </div>
          <div class="col-6 text-right">
            <a v-if="isElectron" class="text-info" href="javascript:" title="Sincronizar impressoras" @click="getPrinters()">
              <i class="fa fa-sync-alt"></i>
            </a>
          </div>
        </div>
        <hr>
        <div class="row">
          <div class="col-12 mb-2">
            <label class="mb-0">Nome da Impressora</label>
            <input
              v-model="dados.descricao"
              class="form-control"
              maxlength="100"
              placeholder="Ex: Cozinha"
              required
              type="text"
            >
          </div>
          <div class="col-12 mb-2">
            <label class="mb-0">Impressora</label>
            <select v-model="dados.nome_sistema" class="form-control">
              <option value="">Selecione um dispositivo</option>
              <option v-for="p in printers" :key="p.displayName" :value="p.displayName">
                {{ p.name }}{{ p.isDefault ? ' (Padrão)' : '' }}
              </option>
            </select>
          </div>
          <div class="col-12 mb-2">
            <label class="mb-0">Tamanho da bobina (mm)</label>
            <select v-model="dados.tamanho_bobina_mm" class="form-control">
              <option :value="80">80 mm</option>
              <option :value="75">75 mm</option>
              <option :value="70">70 mm</option>
              <option :value="65">65 mm</option>
              <option :value="58">58 mm</option>
              <option :value="55">55 mm</option>
            </select>
          </div>
          <div class="col-12 mb-2">
            <label class="mb-0">Tamanho da fonte</label>
            <select v-model="dados.fonte_tamanho" class="form-control">
              <option :value="7">Fonte 1</option>
              <option :value="9">Fonte 2</option>
              <option :value="11">Fonte 3</option>
              <option :value="13">Fonte 4</option>
              <option :value="15">Fonte 5</option>
            </select>
          </div>
        </div>
      </div>
    </div>
    <div class="border-top p-2 text-center d-flex justify-content-between">
      <div class="d-flex justify-content-between w-100">
        <button class="btn btn-light border p-3" @click="$emit('fechar')">
          <i class="fa fa-angle-left"></i> Voltar
        </button>
        <button :disabled="load" class="btn btn-success px-4 p-3" @click="salvarImpressora">
          Salvar
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import Loading from "../../gestor/loading";

export default {
  name: "ImpressoraNova",
  components: { Loading },

  data() {
    return {
      load: false,
      dados: {
        id_impressora: null,
        descricao: '',
        nome_sistema: '',
        tamanho_bobina_mm: 70,
        fonte_tamanho: 13
      }
    }
  },

  methods: {
    normalizarDados(impressora) {
      return {
        id_impressora: impressora && impressora.id_impressora ? impressora.id_impressora : null,
        descricao: impressora && impressora.descricao ? impressora.descricao : '',
        nome_sistema: impressora && impressora.nome_sistema ? impressora.nome_sistema : '',
        tamanho_bobina_mm: Number(impressora && impressora.tamanho_bobina_mm ? impressora.tamanho_bobina_mm : 70),
        fonte_tamanho: Number(impressora && impressora.fonte_tamanho ? impressora.fonte_tamanho : 13)
      };
    },

    salvarImpressora() {
      if (!this.dados.descricao.trim()) {
        this.$swal("A descrição da impressora não pode ficar em branco!");
        return;
      }

      const payload = {
        descricao: this.dados.descricao.trim(),
        nome_sistema: (this.dados.nome_sistema || '').trim() || null,
        tamanho_bobina_mm: Number(this.dados.tamanho_bobina_mm || 70),
        fonte_tamanho: Number(this.dados.fonte_tamanho || 13)
      };

      if (this.dados.id_impressora) {
        payload.id_impressora = this.dados.id_impressora;
      }

      this.load = true;

      this.$http.post('v2/impressao/impressora', payload)
        .then(response => {
          this.load = false;

          if (response.data?.success) {
            this.$swal(
              this.dados.id_impressora
                ? "Impressora editada com sucesso!"
                : "Impressora cadastrada com sucesso!"
            );
            this.$emit('salvar');
            return;
          }

          this.$swal('Erro ao salvar impressora.');

        }, res => {
          this.load = false;
          this.$swal((res.data || {}).erro || (res.data || {}).msg || 'Erro temporário');
        });
    },

    getPrinters() {
      document.dispatchEvent(new CustomEvent('getPrinters'));
      this.$store.state.load = "Aguarde..";

      setTimeout(() => {
        this.$store.state.load = false;
        this.$swal("Impressoras sincronizadas com sucesso!");
      }, 2000);
    }
  },

  computed: {
    printers() {
      return this.$store.state.printers;
    }
  },

  created() {
    this.$parent.$on('loadDadosModal', (impressora) => {
      this.dados = this.normalizarDados(impressora || {});
    });
  }
}
</script>
